module.exports = __webpack_public_path__ + "static/img/service-use02.9555e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/service-use02.png
// module id = 2VRa
// module chunks = 0